import { makeAutoObservable, runInAction, toJS } from "mobx";
import { req } from "./api.config";
import ApiData from "./ApiData";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../config.json";
import RolesState from "./RolesState";
import { getStoredUser } from "../utils/auth.utils";

const url_server = config.url_api;

class User {
  constructor() {
    makeAutoObservable(this);
  }

  user = getStoredUser();
  // user = null;

  user_permission = []; // Массив с ролями юзера
  all_role = []; // Все роли
  all_permission = []; // Все разрешения
  all_rights = []; // Все права
  group_rights = []; // Сгруппированые все права
  role = {}; // Выбранная роль
  role_permission = []; //Разрешение у роли
  role_permission_data = []; //Разрешение у роли
  role_permission_basic = []; //Разрешение у роли
  add_rights = []; // Массив для добавления прав
  delete_rights = []; // Массив для удаления прав
  add_rights_data = []; // Массив для добавления прав
  delete_rights_data = []; // Массив для удаления прав
  flag_permission = false; // Флаг обновления прав
  role_id = null;
  admin_user = ["post_user", "set_activ"];
  admin_role = [
    "get_all_rights",
    "get_roles_id",
    "patch_roles_id",
    "post_roles",
    "delete_roles",
    "get_rights_id",
    "post_permission",
    "delete_permission",
    "patch_permission_id",
    "get_permission_id",
    "get_all_permission",
  ];
  admin_clientid = ["patch_client_id", "delete_licensing"];
  patch_subscription = [
    "post_subscription",
    "delete_subscription",
    "patch_subscription_prol",
    "get_integration_1c_prices",
  ];
  get_company = ["get_country", "get_filter_country"];
  get_company_partners_group = ["get_country", "get_filter_country"];
  patch_company_group = [
    "patch_company_assign_manager",
    "patch_company_assign_support_manager",
  ];
  company_partner_link_rights = [
    "post_company_partner_link",
    "patch_company_partner_link",
  ];
  company_partners_master_rights = ["get_company_partners"];
  hidden_rights_ui = [
    "get_temporary_license",
    "post_temporary_license_approval",
  ];
  all_soft_client_id_admin = ["get_all_soft_client"];
  all_soft_client_id_admin = ["patch_activity_license_id"];
  ckeck_licensing = ["get_expiring_codes"];
  get_licensing = ["patch_attach_id", "patch_licen_prol_id"];
  patch_licensing_group = ["patch_activity_license_id"];
  patch_production = ["delete_production"];

  setParameter = (name, value) => {
    this[`${name}`] = value;
  };

  setParameterUser = (name, value) => {
    if (this.user) {
      this.user[name] = value;
    }
  };

  // Получить список ролей
  allRole = async () => {
    try {
      if (localStorage.getItem("User") === null) return;

      if (RolesState.all_roles) {
        const res = await req(`roles`);
        if (res.status === 200) {
          runInAction(() => {
            this.all_role = res.data.data.request;
            ApiData.observableUser = false;
          });

          return true;
        }
      }
    } catch (e) {
      console.error(e);
    }
  };
  //   Получить все разрешения
  allPermission = async () => {
    this.role_permission_data = [];
    try {
      const res = await req(`permission?${9999}`);
      if (res.status === 200) {
        this.all_permission = res.data["data"]["request"];
      }
    } catch (e) {
      console.error(e);
    }
  };
  //   Получить все права
  allRights = async () => {
    if (localStorage.getItem("User") === null) return;
    if (
      this.user.permission.includes("get_all_rights") ||
      this.user.is_superuser
    ) {
      const res = await req(`rights?${ApiData.sizeItem}`);
      if (res.status === 200) {
        console.log(res.data.data.request);
        this.all_rights = res.data["data"]["request"];
        this.overkillRightsAll();
      }
    }
  };
  overkillRightsAll = async () => {
    this.all_rights.map((per) => {
      return (per.activ = false);
    });
  };

  //   Прочитать роль
  getRole = async (role) => {
    this.add_rights = [];
    this.role = role;
    await this.getRolePermission();
  };
  // Получить права/разрешения у роли
  getRolePermission = async () => {
    try {
      this.role_permission = [];
      const res = await req(`permission/${this.role.id}`);
      if (res.status === 200) {
        runInAction(() => {
          console.log(res.data.data.request);
          this.role_permission = res.data["data"].request;
          this.flag_permission = true;
        });
        this.overkillRolePermission();
      }
    } catch (e) {
      console.error(e);
    }
  };

  overkillRolePermission = async () => {
    this.role_permission_data = [...this.all_rights];
    if (this.role_permission !== undefined) {
      this.role_permission_data.forEach((rights) => {
        const permission = this.role_permission.find(
          (p) => rights.name_rights === p.rights,
        );
        if (permission) {
          rights.activ = true;
        }
      });
    }
  };
  //   Сгрупипровать права
  groupRights = async () => {
    this.group_rights = [];
    this.all_rights.forEach((right) => {
      if (
        !this.group_rights.includes(right.category) &&
        right.category !== "Разрешения" &&
        right.category !== "Права" &&
        right.category !== "Мой профиль" &&
        right.category !== "archive" &&
        right.category !== "ПО" &&
        right.category !== "Партнёры"
      ) {
        this.group_rights.push(right.category);
      }
    });
  };
  //   Установка разрешений
  installRights = async (e) => {
    if (localStorage.getItem("User") === null) return;
    if (
      this.user.is_superuser ||
      (this.user.permission.includes("post_permission") &&
        this.user.permission.includes("delete_permission"))
    ) {
      if (e.name_rights === "get_all_soft_client" && e.activ) {
        const permissionID = this.role_permission_data.find(
          (p) => p.id === e.id,
        );
        if (permissionID) {
          const permissionPatchID = this.role_permission_data.find(
            (s) => s.name_rights === "patch_client_id",
          );
          if (permissionPatchID) {
            permissionPatchID.activ = false;
          }
          permissionID.activ = false;
          this.deleteRigths(["get_all_soft_client", "patch_client_id"]);
        }
      } else {
        this.role_permission_data.find((p) => {
          if (p.id === e.id) {
            if (p.activ) {
              p.activ = false;
              this.deleteRigths([e.name_rights]);
            } else {
              p.activ = true;
              this.addRights([e.name_rights]);
            }
          }
        });
      }
    }
  };

  //   Добавить права у роли
  addRights = async (rights) => {
    try {
      await req.post(`permission`, {
        id_role: this.role.id,
        name_rights: rights,
      });
    } catch (e) {
      console.error(e);
    }
  };
  deleteRigths = async (rights) => {
    await req.delete("permission", {
      data: { id_role: this.role.id, name_rights: rights },
    });
  };

  //   Добавить новыю роль
  addRole = async (name) => {
    if (this.addRoleTimeoutId !== null) {
      clearTimeout(this.addRoleTimeoutId);
      this.addRoleTimeoutId = null;
    }
    let res;
    try {
      res = await req.post(`roles`, { role_name: name });
    } catch (e) {
      console.error(e);
    } finally {
      const roleId = res?.data?.["data"]?.id;
      if (roleId == null) {
        return;
      }
      this.addRoleTimeoutId = setTimeout(async () => {
        this.addRoleTimeoutId = null;
        try {
          await req.post(`permission`, {
            id_role: roleId,
            name_rights: [
              "get_my_profile",
              "patch_my_profile",
              "patch_change_password",
            ],
          });
          this.allRole();
        } catch (e) {
          console.error(e);
        }
      }, 1000);
    }
  };

  //   Установка роли юзеру
  setUserRole = async (user) => {
    try {
      await req.patch(`permission/relationship`, {
        id_user: ApiData.employee.id,
        id_role: user,
      });
    } catch (e) {
      console.error(e);
    }
  };

  //  Дать права суперюзера
  superUser = async (id, boolean) => {
    await req.patch(`permission/superuser/${id}`, { is_superuser: boolean });
    await ApiData.getDataEmployees();
  };

  //   Изменение роли
  updateRole = async (new_name) => {
    try {
      const res = await req.patch(`roles/${this.role.id}`, {
        role_name: new_name,
      });
      if (res.status === 200) {
        await this.allRole();
      }
    } catch (e) {
      console.error(e);
    }
  };

  //   Перезапрос прав
  refreshRights = async () => {
    try {
      await req(`permission/${this.role.id}`);
    } catch (e) {
      console.error(e);
    }
  };
  // Удалить роль
  deleteRole = async (e) => {
    try {
      const res = await req.delete("roles", { data: { id_role: e.id } });
      if (res.status === 200) {
        await this.allRole();
      }
    } catch (e) {
      console.error(e);
    }
  };

  // Активировать/деактивировать пользователя
  setActiveUser = async (boolen, id) => {
    try {
      const res = await req.patch(`user/set_active/${id}`, {
        is_activ: boolen,
      });
      if (res.status === 200) {
        await ApiData.getDataEmployees();
      }
    } catch (e) {
      console.error(e);
    }
  };

  setAdminEmploees = async () => {
    try {
      let rigth = ["post_user"];
      const sub_rigths = [
        "get_all_user",
        "get_user_id",
        "update_user",
        "patch_relationship",
      ];
      const postUserID = this.role_permission_data.find(
        (p) => p.name_rights === "post_user",
      );
      if (!postUserID.activ) {
        sub_rigths.forEach((sr) => {
          const subRigthID = this.role_permission_data.find(
            (sp) => sp.name_rights === sr,
          );
          if (subRigthID && !subRigthID.activ) {
            rigth = [...rigth, sr];
          }
        });
        this.addRights(rigth);
        rigth.forEach((new_rigth) => {
          const newRigthID = this.role_permission_data.find(
            (sp) => sp.name_rights === new_rigth,
          );
          if (newRigthID) {
            newRigthID.activ = true;
          }
        });
      } else {
        this.deleteRigths(["post_user"]);
        postUserID.activ = false;
      }
    } catch (e) {
      console.error(e);
    }
  };

  setAdminRoles = async () => {
    try {
      let rigth = [];
      const sub_rigths = [];
      const postRoleID = this.role_permission_data.find(
        (p) => p.name_rights === "get_roles_id",
      );
      const getAllRolesID = this.role_permission_data.find(
        (p) => p.name_rights === "get_all_roles",
      );
      if (!getAllRolesID.activ) {
        sub_rigths.push("get_all_roles");
      }
      if (!postRoleID.activ) {
        sub_rigths.forEach((sr) => {
          const subRigthID = this.role_permission_data.find(
            (sp) => sp.name_rights === sr,
          );
          if (subRigthID && !subRigthID.activ) {
            rigth = [...rigth, sr];
          }
        });
        this.admin_role.forEach((sr) => {
          const subRigthID = this.role_permission_data.find(
            (sp) => sp.name_rights === sr,
          );
          if (subRigthID && !subRigthID.activ) {
            rigth = [...rigth, sr];
          }
        });
        await this.addRights(rigth);
        rigth.forEach((new_rigth) => {
          const newRigthID = this.role_permission_data.find(
            (sp) => sp.name_rights === new_rigth,
          );
          if (newRigthID) {
            newRigthID.activ = true;
          }
        });
      } else {
        await this.deleteRigths(this.admin_role);
        this.admin_role.forEach((new_rigth) => {
          const newRigthID = this.role_permission_data.find(
            (sp) => sp.name_rights === new_rigth,
          );
          if (newRigthID) {
            newRigthID.activ = false;
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  setAdminClientID = async () => {
    try {
      // const right = ["patch_client_id"];
      const postClientID = this.role_permission_data.find(
        (p) => p.name_rights === "patch_client_id",
      );
      const getAllSoftClientID = this.role_permission_data.find(
        (p) => p.name_rights === "get_all_soft_client",
      );

      if (!getAllSoftClientID.activ) {
        this.admin_clientid = [...this.admin_clientid, "get_all_soft_client"];
      }
      if (!postClientID.activ) {
        await this.addRights(this.admin_clientid);
        const allSoftClientID = this.role_permission_data.find(
          (p) => p.name_rights === "get_all_soft_client",
        );
        postClientID.activ = true;
        allSoftClientID.activ = true;
      } else {
        await this.deleteRigths(this.admin_clientid);
        postClientID.activ = false;
      }
    } catch (e) {
      console.error(e);
    }
  };

  // Универсальная функция добавления и удаления у группы прав
  applyGroupRight = async (group, name, sudData) => {
    const right = [...this[`${group}`], name];
    const updateID = this.role_permission_data.find(
      (p) => p.name_rights === name,
    );
    if (!updateID.activ) {
      if (sudData) {
        sudData.map(async (r) => {
          const rightID = this.role_permission_data.find(
            (rd) => r === rd.name_rights,
          );
          if (!rightID.activ) {
            rightID.activ = true;
            await this.addRights([r]);
          }
        });
      }

      right.map(async (r) => {
        const updateRight = [];
        const rightID = this.role_permission_data.find(
          (rd) => r === rd.name_rights,
        );
        if (!rightID.activ) {
          updateRight.push(rightID.name_rights);
          rightID.activ = true;
        }
        await this.addRights(updateRight);
      });
    } else {
      right.map(async (r) => {
        const updateRight = [];
        const rightID = this.role_permission_data.find(
          (rd) => r === rd.name_rights,
        );
        if (rightID.activ) {
          updateRight.push(rightID.name_rights);
          rightID.activ = false;
        }
        await this.deleteRigths(updateRight);
      });
    }
  };

  setGetCompany = async () => {
    const right = [...this.get_company, "get_all_company"];
    try {
      const patchSubscriptionID = this.role_permission_data.find(
        (p) => p.name_rights === "get_all_company",
      );
      if (!patchSubscriptionID.activ) {
        await this.addRights(right);
        patchSubscriptionID.activ = true;
      } else {
        await this.deleteRigths(right);
        patchSubscriptionID.activ = false;
      }
    } catch (e) {
      console.error(e);
    }
  };

  setPatchSubscription = async () => {
    const right = [...this.patch_subscription, "patch_subscription"];
    try {
      const patchSubscriptionID = this.role_permission_data.find(
        (p) => p.name_rights === "patch_subscription",
      );
      if (!patchSubscriptionID.activ) {
        await this.addRights(right);
        patchSubscriptionID.activ = true;
      } else {
        await this.deleteRigths(right);
        patchSubscriptionID.activ = false;
      }
    } catch (e) {
      console.error(e);
    }
  };

  setPatchSoftAndLic = async () => {
    try {
      const patchSoftAndLicID = this.role_permission_data.find(
        (p) => p.name_rights === "get_soft_company_id",
      );
      if (!patchSoftAndLicID.activ) {
        await this.addRights(["get_license_id", "get_soft_company_id"]);
        patchSoftAndLicID.activ = true;
      } else {
        await this.deleteRigths(["get_license_id", "get_soft_company_id"]);
        patchSoftAndLicID.activ = false;
      }
    } catch (e) {
      console.error(e);
    }
  };
}

export default new User();
